// The theme's typefaces (styles/_tokens.scss), loaded by the page (main-component/Utsav).
export const UTSAV_FONTS =
  "https://fonts.googleapis.com/css2?family=Amita:wght@400;700&family=Great+Vibes&family=Lora:ital,wght@0,400;0,500;0,600;1,400&family=Playfair+Display:ital,wght@0,500;0,600;0,700;1,500&display=swap";
